export default "__VITE_ASSET__dKgP5fEt__"